import Component from "@lib/Component.js";

export default class MapBox extends Component {
  init() {
    super.init();

    this.markers = [];

    this.addMapboxScript();
  }

  onEnterCompleted() {
    super.onEnterCompleted();
  }

  addMapboxScript() {
    if (document.head.querySelector("#mapbox")) {
      this.initMapBox();
      this.addMarkers();
      return;
    }

    var script = document.createElement("script");
    script.id = "mapbox";
    script.src = "https://api.mapbox.com/mapbox-gl-js/v1.4.1/mapbox-gl.js";
    var self = this;
    script.onload = function() {
      self.initMapBox();
      self.addMarkers();
    };

    document.head.appendChild(script);

    var link = document.createElement("link");
    link.href = "https://api.mapbox.com/mapbox-gl-js/v1.4.1/mapbox-gl.css";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }

  initMapBox() {
    mapboxgl.accessToken = "pk.eyJ1IjoiYWRyaWVuYWthcnUiLCJhIjoiY2syMDlncDhhMDRuMzNnbnlwc3Jnc2sweiJ9.HUnzCoToIXT2Xw4_yCU1WQ";
    this.map = new mapboxgl.Map({
      container: this.el,
      style: "mapbox://styles/adrienakaru/ck5fdoemm0sga1imspoizwtn9",
      attributionControl: false,
      pitchWithRotate: false,
      interactive: this.el.clientWidth < 1024,
      zoomControl: false,
      dragRotate: false,
      center: [6.214461919264181, 46.0051449420412]
    });

    this.map.scrollZoom.disable();
    this.map.doubleClickZoom.disable();
    /*
    this.map.addControl(
      new mapboxgl.NavigationControl({
        showCompass: false
      })
    );
    */
  }

  addMarkers() {
    if (!this.map) return;

    var markerElm = this.el.querySelector(".mapbox-marker");

    var mapdata = [
      {
        label: "France",
        position: [2.213749, 46.227638]
      },
      {
        label: "Espagne",
        position: [-3.74922, 40.463667]
      },
      {
        label: "Georgia",
        position: [-80.57373, 31.890618]
      },
      {
        label: "Amérique du sud",
        position: [-39.418945, -19.199128]
      },
      {
        label: "Australie",
        position: [120.541992, -20.109586]
      },
      {
        label: "Japon",
        position: [138.252924, 36.204824]
      }
    ];

    for (var i = 0; i < mapdata.length; i++) {
      const item = mapdata[i];

      try {
        // add marker to map
        const el = markerElm.cloneNode(true);
        // el.addEventListener("click", self.onClickMarker);
        el.classList.add("show");
        //el.classList.add(item["atelier-de-fabrication"]);
        el.setAttribute("data-id", i);

        const marker = new mapboxgl.Marker(el).setLngLat(item.position).addTo(this.map);
        this.markers.push(marker);
      } catch (err) {
        console.info(err);
        console.info(item);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/MapBox.js